// extracted by mini-css-extract-plugin
export var aboutExtra = "Extra-module--aboutExtra--SHnag";
export var extrasContainer = "Extra-module--extrasContainer--LHFAg";
export var extra = "Extra-module--extra--1I_p6";